import './SidebarCard.scss';
import { useLocation } from 'react-router-dom'
import SidebarCardProps from './SidebarCardProps';
import { BsArrowRight as ArrowRightIcon } from "react-icons/bs";
import { useDispatch } from 'react-redux';
import { toggleCommunityPopup } from '../../../store/actions/mainActions';

const SidebarCard = (props: SidebarCardProps) => {
    const dispatch = useDispatch();
    const location = useLocation();

    const { type, top, title, highlightText, highlightColor, icon, children, btnText, className } = props;
    const pathname = location.pathname;
    const showCommunityPopup = () => {
        dispatch(toggleCommunityPopup(true))
    }

    return (
        <div className={"sidebar-card animate__animated animate__slideInLeft " + className} style={{ top: top }}>
            { title && highlightText && icon &&
                <div className="title-wrapper px-3">
                    <div className="title">
                        <div className="mx-1">{

                            type === 'community' && pathname.startsWith('/my-campus/event') ? 'Seminar' :
                            type === 'community' && pathname.startsWith('/my-campus/course') ? 'Seminar' :
                            type === 'community' && (pathname === '/' || pathname.startsWith('/content') || pathname.startsWith('/my-communities') || pathname.startsWith('/my-campus')) ? title :
                            type === 'community' && pathname.startsWith('/community') ? 'Community' : title
                        
                        }</div>
                        <div className="font-italic font-weight-bold" style={{ color: highlightColor }}>{
                            type === 'community' && (pathname.startsWith('/my-campus/event') || pathname.startsWith('/my-campus/course')) ? 'Participants' : 
                            type === 'community' && (pathname === '/' || pathname.startsWith('/content') || pathname.startsWith('/my-communities') || pathname.startsWith('/my-campus')) ? 'Community' :
                            type === 'community' && pathname.startsWith('/community') ? 'Community' : highlightText
                        }</div>
                    </div>
                    <img src={icon} alt="community-icon" />
                </div>
            }
            <div
                className="body"
                style={type !== 'profile' ? { height: '300px', overflowY: 'scroll' } : { height: 'auto', overflowY: 'hidden' }}
            >
                {children}
            </div>
            {btnText &&
                <div className="button" onClick={showCommunityPopup}>
                    <div className="button-text">{btnText}</div>
                    <ArrowRightIcon className="arrow-icon" />
                </div>
            }
        </div>
    )
}

export default SidebarCard;
